export default "__VITE_ASSET__DlOclSnT__"